// Refactored ProfileComponent (Core Form Logic)
import { Component, OnInit, ChangeDetectorRef, OnDestroy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';

import { AccountService } from './../../services/account.service';
import { UtilService } from '../../services/util.service';
import { GlobalValidators } from './../../utils/validators';
import { OpenDialog } from '../../shared/dialogs/dialog';
import { ConfirmPasswordComponent } from './../confirm-password/confirm-password.component';
import { IdleLogoutService } from '../../services/idle-logout.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss'],
})
export class ProfileComponent implements OnInit, OnDestroy {
  customerProfileFG: FormGroup;
  changePasswordFG: FormGroup;
  changeEmailFG: FormGroup;
  changeMobileFG: FormGroup;
  verifySignupFG: FormGroup;

  uploadError: any;
  submitError: any;
  errorMessages: string[] = [];
  avatarImageFormControl = new FormControl([]);

  currentUser: any;
  avatarImageChanged = false;
  successMsg: string = '';
  activadedTab = 'edit-profile';
  collapseibleTab;
  sentVerification;
  changeMobileInProgress;
  changeMobileErrors: any;
  verifyMobileSuccessMsg;
  sentMobileVerification;
  customerProfileInProgress;
  customerProfileSuccessMsg;
  editUserInfo;
  private destroy$ = new Subject<void>();

  getProfileYear(): number {
    if (this.currentUser?.createdAt) {
      return new Date(this.currentUser.createdAt).getFullYear();
    }
    if (this.currentUser?.createdDate) {
      return new Date(this.currentUser.createdDate).getFullYear();
    }
    if (this.currentUser?.registrationDate) {
      return new Date(this.currentUser.registrationDate).getFullYear();
    }
    // Fallback to current year or a default year
    return new Date().getFullYear();
  }

  constructor(
    private fb: FormBuilder,
    private accountService: AccountService,
    private utilService: UtilService,
    private cdRef: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    private idleLogoutService: IdleLogoutService,
    public translate: TranslateService,
  ) {}

  async ngOnInit() {
    this.currentUser = await this.accountService.currentUserAsync();

    this.avatarImageFormControl.setValue(this.currentUser.avatarUrl || 'assets/images/default-profile-pic-plus.png');
    this.avatarImageFormControl.valueChanges.subscribe((value) => {
      this.accountService.updateAvatar({ avatarUrl: value }).then(() => {
        this.accountService.currentUser.avatarUrl = value;
        this.accountService.emitProfile(true);
        this.avatarImageChanged = true;
        setTimeout(() => {
          this.avatarImageChanged = false;
        }, 2000);
      });
    });

    await this.buildForms(this.currentUser);
    await this.bindChangeMobileForm(this.currentUser);
    await this.patchProfileData();
    console.log(this.changeMobileFG, 82);
    // Initialize idle logout for profile module
    this.idleLogoutService.initializeIdleLogout('profile');
    this.cdRef.detectChanges();
  }

  buildForms(data) {
    this.customerProfileFG = this.fb.group({
      firstName: [data?.firstName || '', GlobalValidators.required],
      lastName: [data?.lastName || '', GlobalValidators.required],
      email: [{ value: data?.email || '', disabled: true }],
    });

    this.changePasswordFG = this.fb.group(
      {
        currentPassword: ['', GlobalValidators.required],
        newPassword: ['', [GlobalValidators.required, GlobalValidators.password()]],
        confirmPassword: ['', GlobalValidators.required],
      },
      {
        validators: GlobalValidators.misMatchPasswords('newPassword', 'confirmPassword'),
      },
    );

    this.changeEmailFG = this.fb.group({
      email: ['', [GlobalValidators.required, GlobalValidators.email]],
    });

    this.verifySignupFG = this.fb.group({
      email: ['', GlobalValidators.required],
      verificationCode: ['', GlobalValidators.required],
    });
  }
  bindChangeMobileForm(data?) {
    this.changeMobileFG = this.fb.group({
      mobilePhoneCountryCode: ['880', GlobalValidators.required],
      mobilePhoneAreaCode: [data?.mobilePhoneAreaCode || '', GlobalValidators.required],
      mobilePhoneNumber: [data?.mobilePhoneNumber || '', GlobalValidators.required],
      verificationCode: ['', GlobalValidators.required],
      sentVerification: [false],
      enteredCode: [],
    });
  }
  changeMobile(form) {
    if (form.invalid) {
      return;
    }
    console.log(form);
    // console.log(this.changeMobileFG.get('verificationCode').value);
    let verificationCode = this.changeMobileFG.get('verificationCode').value;
    OpenDialog(ConfirmPasswordComponent, {
      saveCb: async (password) => {
        this.changeMobileInProgress = true;
        this.changeMobileErrors = [];
        this.sentMobileVerification = true;
        this.changeMobileInProgress = false;
        try {
          this.submitError = undefined;
          console.log('works here ', verificationCode);
          await this.accountService.verifyMobileConfirmation({
            mobilePhoneCountryCode: form.value.mobilePhoneCountryCode,
            mobilePhoneAreaCode: form.value.mobilePhoneAreaCode,
            mobilePhoneNumber: form.value.mobilePhoneNumber,
            verificationCode: form.value.verificationCode,
            password: password,
          });
          console.log('works here  mmmm', verificationCode);

          this.currentUser.mobilePhoneCountryCode = form.value.mobilePhoneCountryCode;
          this.currentUser.mobilePhoneAreaCode = form.value.mobilePhoneAreaCode;
          this.currentUser.mobilePhoneNumber = form.value.mobilePhoneNumber;
          this.accountService.emitProfile(true);

          this.sentMobileVerification = true;
          this.changeMobileInProgress = false;
          return 'success';
        } catch (e) {
          this.changeMobileErrors = ['Mobile is not Correct'];
          this.changeMobileInProgress = false;
          this.submitError = e.error;
          if (this.submitError.errorCode === '3') {
            if (this.submitError.message === 'Incorrect verification code') {
              return 'incorrectverification';
            } else {
              return 'incorrectPassword';
            }
          }
          return 'serverError';
        }
      },
    }).then(async (password) => {
      this.customerProfileInProgress = false;
      this.currentUser = await this.accountService.loadCurrentUserFromServer();
      this.bindChangeMobileForm(this.currentUser);
    });
    this.cdRef.detectChanges();
  }
  patchProfileData() {
    if (!this.currentUser) return;
    this.customerProfileFG.patchValue({
      firstName: this.currentUser.firstName,
      lastName: this.currentUser.lastName,
      email: this.currentUser.email,
    });
  }

  async onSubmitProfile() {
    if (this.customerProfileFG.invalid) return;

    OpenDialog(ConfirmPasswordComponent, {
      saveCb: async (password) => {
        const profileData = {
          ...this.customerProfileFG.getRawValue(),
          password,
        };
        try {
          await this.accountService.updateProfile(profileData);
          this.successMsg = 'Profile updated successfully';
          this.cdRef.detectChanges();
          setTimeout(() => (this.successMsg = ''), 3000);
          return 'success';
        } catch (e) {
          this.handleError(e);
          return 'serverError';
        }
      },
    });
  }
  customerProfile(form) {
    if (form.invalid) {
      return;
    }
    this.customerProfileInProgress = true;
    OpenDialog(ConfirmPasswordComponent, {
      saveCb: async (password) => {
        try {
          this.submitError = undefined;
          form.value.password = password;
          console.log(password);
          await this.accountService.updateProfile(form.value);
          this.customerProfileInProgress = false;
          this.currentUser.mobilePhoneAreaCode = form.value.mobilePhoneAreaCode;
          this.currentUser.mobilePhoneNumber = form.value.mobilePhoneNumber;
          // if (!this.currentUser.crmContactExist) {
          this.accountService.currentUser.firstName = form.value.firstName;
          this.accountService.currentUser.lastName = form.value.lastName;
          this.accountService.emitProfile(true);
          // window.location.reload();
          // }
          setTimeout(() => {
            this.customerProfileSuccessMsg = true;
          }, 1000);
          setTimeout(
            () => {
              this.customerProfileSuccessMsg = false;
            },
            5 * 60 * 60,
          );
          this.editUserInfo = !this.editUserInfo;
          return 'success';
        } catch (e) {
          this.customerProfileInProgress = false;
          this.submitError = e.error;
          if (this.submitError.errorCode === '3') {
            if (this.submitError.message === 'Incorrect verification code') {
              return 'incorrectverification';
            } else {
              return 'incorrectPassword';
            }
          }
          return 'serverError';
        }
      },
    }).then(() => {
      this.customerProfileInProgress = false;
    });
  }
  async onChangePassword() {
    if (this.changePasswordFG.invalid) return;
    try {
      await this.accountService.changePassword(this.changePasswordFG.value);
      this.router.navigate(['/signin']);
    } catch (e) {
      this.errorMessages = ['Incorrect current password'];
    }
  }

  async onSendEmailVerification() {
    if (this.changeEmailFG.invalid) return;
    try {
      await this.accountService.sendEmailConfirmation(this.changeEmailFG.value);
    } catch (e) {
      this.errorMessages = ['Invalid email address'];
    }
  }

  async onVerifySignup() {
    if (this.verifySignupFG.invalid) return;
    try {
      await this.accountService.verifyEmailConfirmation(this.verifySignupFG.value);
    } catch (e) {
      this.errorMessages = ['Invalid verification code'];
    }
  }

  async onChangeMobile() {
    if (this.changeMobileFG.invalid) return;

    OpenDialog(ConfirmPasswordComponent, {
      saveCb: async (password) => {
        const mobileData = {
          ...this.changeMobileFG.value,
          password,
        };
        try {
          await this.accountService.verifyMobileConfirmation(mobileData);
          return 'success';
        } catch (e) {
          this.handleError(e);
          return 'serverError';
        }
      },
    });
  }

  handleError(error: any) {
    this.submitError = error?.json?.() || error?.message || 'Unknown error';
    this.cdRef.detectChanges();
  }
  activeTab(tab) {
    this.activadedTab = tab;
    this.cdRef.detectChanges();
  }
  collapse(tab) {
    if (this.collapseibleTab === tab) {
      this.collapseibleTab = '';
    } else {
      this.collapseibleTab = tab;
    }
    this.cdRef.detectChanges();
  }
  setUploadError(error) {
    this.uploadError = error;
    setTimeout(() => {
      this.uploadError = undefined;
    }, 2400);
  }
  async sendMobileVerificationCode() {
    try {
      this.sentVerification = true;

      await this.accountService.sendMobileConfirmation({
        mobilePhoneCountryCode: this.changeMobileFG.get('mobilePhoneCountryCode').value,
        mobilePhoneAreaCode: this.changeMobileFG.get('mobilePhoneAreaCode').value,
        mobilePhoneNumber: this.changeMobileFG.get('mobilePhoneNumber').value,
      });
      this.changeMobileFG.get('sentVerification').setValue(true, { emitEvent: true });
      this.sentVerification = false;
      this.cdRef.detectChanges();
    } catch (e) {
      this.sentVerification = false;
      this.cdRef.detectChanges();
    }
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();

    // Disable idle logout when component is destroyed
    this.idleLogoutService.disableIdleLogout();
  }
}
